export default __webpack_public_path__ + "media/images/flags/vt-e1848bef3c1b3b5967921b00662b7c39.png";